import React, { useRef, useState } from 'react'

import * as st from '~/assets/styl/OutsourcingContactForm.module.styl'

import bgTerceirizacao from '~/assets/img/form-terceirizacao-background.jpg'
import { AnchorLink } from 'gatsby-plugin-anchor-links'
import ReCAPTCHA from 'react-google-recaptcha'
import api from '~/siteApi'

import formatPhone from '~/utils/formatPhone'
import { navigate } from 'gatsby'

export default function OutsourcingContactForm() {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [privacy, setPrivacy] = useState(false)
  const [communications, setCommunications] = useState(false)
  const recaptchaRef = useRef<ReCAPTCHA>()

  function handleName(e) {
    setName(e.target.value)
  }

  function handleEmail(e) {
    setEmail(e.target.value)
  }

  function handlePhone(e) {
    setPhone(formatPhone(e.target.value))
  }

  function handleTermo(e) {
    setPrivacy(e.target.checked)
  }

  function handleComunicacao(e) {
    setCommunications(e.target.checked)
  }

  function handleSubmit(e) {
    e.preventDefault()

    recaptchaRef.current.executeAsync().then((recaptcha) => {
      recaptchaRef.current.reset()

      const bypass = process.env.GATSBY_RECAPTCHA_BYPASS
      const isDev = process.env.NODE_ENV === 'development'

      api('post', 'leads/outsourcing', {
        name,
        email,
        phone,
        privacy,
        consent: communications,
        recaptcha: isDev && bypass ? bypass : recaptcha,
      })
        .then(() => {
          setName('')
          setEmail('')
          setPhone('')
          navigate('/obrigado')
        })
        .catch((error) => {
          alert(
            error?.message ||
              'Não foi possível enviar seus dados. Tente novamente.'
          )
        })
    })
  }

  return (
    <div
      id="contrate"
      className={st.contactContainer}
      style={{ backgroundImage: `url(${bgTerceirizacao})` }}
    >
      <section className={st.contactWrapper}>
        <h2>Ficou interessado?</h2>
        <p>
          Deixe seus dados, nossa equipe de consultores entrará em contato com
          você.
        </p>
        <form onSubmit={handleSubmit}>
          <div className={st.formWrapper}>
            <label>
              <input
                type="text"
                placeholder="Nome"
                value={name}
                onChange={handleName}
                required
              />
            </label>
            <label>
              <input
                type="email"
                placeholder="E-mail"
                value={email}
                onChange={handleEmail}
                required
              />
            </label>
            <label>
              <input
                type="tel"
                placeholder="Whatsapp"
                value={phone}
                onChange={handlePhone}
                maxLength={15}
                required
              />
            </label>
          </div>
          <div className={st.privacy}>
            <label>
              <input
                id="use_terms_privacy"
                type="checkbox"
                name="termo"
                onChange={handleTermo}
                required
              />
              <small>
                Eu concordo em receber comunicações. Ao informar meus dados, eu
                concordo com a
                <AnchorLink to="/politica-de-privacidade/">
                  Política de privacidade
                </AnchorLink>
                e<AnchorLink to="/termos-de-uso/">Termos de uso</AnchorLink>
              </small>
            </label>
            <label>
              <input
                id="use_terms_comunicacao"
                type="checkbox"
                name="comunicacao"
                onChange={handleComunicacao}
                required
              />
              <small>
                Autorizo o Grupo Dimas a armazenar meus dados pessoais para
                enviar campanhas de marketing e informações sobre a empresa nos
                canais: Telefone, Email e SMS.
              </small>
            </label>
          </div>
          {process.env.GATSBY_RECAPTCHA_KEY && (
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey={process.env.GATSBY_RECAPTCHA_KEY}
              size="invisible"
            />
          )}
          <button type="submit">Solicitar Contato</button>
        </form>
      </section>
    </div>
  )
}
